import cn from 'classnames'
import React, { ComponentProps } from 'react'

type MccLodgingIconProps = {
  className?: string
} & ComponentProps<'svg'>

export default function MccLodgingIcon(props: MccLodgingIconProps) {
  const { className = '', ...rest } = props
  return (
    <svg
      className={cn('MccLodgingIcon', className)}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M1.33331 1.66675V12.3334M1.33331 4.33341H13.3333C13.6869 4.33341 14.0261 4.47389 14.2761 4.72394C14.5262 4.97399 14.6666 5.31313 14.6666 5.66675V12.3334M1.33331 10.3334H14.6666M3.99998 4.33341V10.3334"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
